import { useAuth } from "react-oidc-context";
import { Navigate } from "react-router";

import { Loading } from "design-system/components/Loading";
import { pathsSchema } from "shell/platform/config/paths";
import { consumePostLoginRedirect } from "shell/platform/lib/authRedirect";

export const LoginRedirect = () => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    const redirectTo = consumePostLoginRedirect();
    if (redirectTo) {
      try {
        const url = new URL(redirectTo, globalThis.location.origin);
        if (url.origin === globalThis.location.origin) {
          globalThis.location.assign(url.toString());
          return <Loading isFullScreen size="large" />;
        }
      } catch {
        // fall through
      }
    }

    return <Navigate to={pathsSchema.index} />;
  }

  return <Loading isFullScreen size="large" />;
};
